// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3zqsJ","cell":"ColumnAccessor_cell__kiRS_","firstCellAccent":"ColumnAccessor_firstCellAccent__3Ofq8"};